import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import RecordedSubjectTable from './RecordedSubjectTable';
const RecordedSubject = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Recorded Subject' parent='Recorded Subject'  />
      <Container fluid={true}>
        <Row>
          <RecordedSubjectTable  />
        </Row>
      </Container>
    </Fragment>
  );
};

export default RecordedSubject;
